import type { OpenPostPostingWrapper } from '@festina/life-general-types/life'
import type { SetRequiredAndNonNullable } from '@festina-life/core'
import { Modal } from '@festina-life/ui/structure'

import { useComponent } from '../../lenteHooks'

type Props = {
  /** Modal title. */
  title: string
  postings: SetRequiredAndNonNullable<
    OpenPostPostingWrapper,
    'openPostPosting'
  >[]
  shouldShowAllDimensions?: boolean
  /** Modal state */
  isOpen: boolean
  onClose: () => void
}

export const PostingsModal = ({
  title,
  postings,
  shouldShowAllDimensions,
  onClose,
  isOpen,
}: Props) => {
  const PostingsTable = useComponent('pages.commitment.postings.PostingsTable')

  return (
    <Modal panelClassName="max-w-full" isOpen={isOpen} onClose={onClose}>
      <Modal.Title title={title} />
      <Modal.Body>
        <PostingsTable
          postings={postings}
          shouldShowAllDimensions={shouldShowAllDimensions}
        />
      </Modal.Body>
    </Modal>
  )
}
